module.exports = ".amd-message-container {\n  margin-bottom: 20px; }\n\n.amd-message__text {\n  padding-left: 0; }\n"